import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Projects from './pages/Projects/Projects';
import References from './pages/References/References';
import Contact from './pages/Contact/Contact';
import Dofinansowanie from './pages/Dofinansowanie/Dofinansowanie';
import Error404 from './pages/Error/Error404';
import ScrollToTop from './components/common/ScrollToTop';
import './App.css';
import './styles/globals.css';
import './styles/animations.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/o-firmie" element={<About />} />
            <Route path="/oferta" element={<Services />} />
            <Route path="/nasze-realizacje" element={<Projects />} />
            <Route path="/referencje-i-certyfikaty" element={<References />} />
            <Route path="/kontakt" element={<Contact />} /> 
            <Route path="/dofinansowanie" element={<Dofinansowanie />} />
            {/* Catch-all route for 404 - musi być na końcu */}
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
